<template>
  <div class="flex items-center gap-2">
    <Button
      variant="outline"
      size="sm"
      type="button"
      class="h-8 max-w-64 justify-start truncate"
      :loading="isUpdating"
      @click="openTitleModal"
    >
      <span class="truncate"><span v-if="showLabel" class="text-sm text-muted-foreground">
        Title:
      </span>{{ titleLabel }}</span>
    </Button>

    <TaskTemplateTitleEditModal
      ref="titleModal"
      :task-template-id="taskTemplateId"
      :title="normalizedTitle"
      :context="context"
    />
  </div>
</template>

<script setup>
import { computed, ref } from 'vue'
import { Button } from '../../../../../../../../resources/js/components/ui/button/index.js'
import TaskTemplateTitleEditModal from './TaskTemplateTitleEditModal.vue'
import { useTaskTemplateStore } from '../../../stores/taskTemplateStore.js'

const props = defineProps({
  taskTemplate: {
    type: Object,
    required: true,
  },
  value: {
    type: [String, Object],
    default: null,
  },
  context: {
    type: String,
    default: 'task-template-show',
  },
  showLabel: {
    type: Boolean,
    default: false,
  },
})

const titleModal = ref(null)

const taskTemplateStore = useTaskTemplateStore(props.context)
const taskTemplateId = computed(() => Number(props.taskTemplate?.id))
const isUpdating = computed(() => taskTemplateStore.isUpdatingTitle(taskTemplateId.value))
const normalizedTitle = computed(() => {
  if (typeof props.value === 'string') {
    return props.value
  }

  if (props.value && typeof props.value === 'object' && 'value' in props.value) {
    return String(props.value.value)
  }

  return props.taskTemplate?.title ?? ''
})
const titleLabel = computed(() => normalizedTitle.value?.trim() || 'Untitled task template')

const openTitleModal = () => {
  titleModal.value?.openModal?.()
}
</script>
